import axios from 'axios'

let fileUploadUrl = "/upload/admin";

function postUpload(url, params) {
    let base = ''
    base = process.env.VUE_APP_BASE_API +url

    // let base = baseURL + url;
    return new Promise((resolve, reject) => {
      axios.post(base, params, {
        headers: {
          "Content-Type": false
        }
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  };

      
  export function fileUploadAddress(fileUploadobj) {
    return postUpload(fileUploadUrl, fileUploadobj);
  }